/** @type {number[]} */
export const skillLevels = [];

/**
 * Fill the skill levels array.
 * @param {number} lvl
 */
function fillLevel(lvl) {
  if (lvl > 99) {
    return;
  }
  skillLevels[lvl] =
    Math.floor(0.25 * (lvl - 1 + 300 * 2 ** ((lvl - 1) / 7))) +
    (skillLevels[lvl - 1] || 0);
  fillLevel(lvl + 1);
}

if (skillLevels.length === 0) {
  fillLevel(2);
}

/**
 * Find the level for a given amount of experience.
 * @param {number} exp
 * @returns {number}
 */
export function getLevel(exp) {
  if (exp < 0) {
    return 1;
  }
  for (let i = 2; i < skillLevels.length; i++) {
    if (exp < skillLevels[i]) {
      return i - 1;
    }
  }
  return skillLevels.length - 1;
}
